/**
 * 用户相关
 */
import { logout, login, getUserInfo } from "@/api/modules/user"
import { vab } from "@libs/utils"
import { routeTo } from "@/utils"
import { getToken, removeToken, setUserId, removeUserId, getUserId } from "@/utils/auth"

export default {
  state: {
    token: getToken(), // token
    userId: getUserId(), // 会员id
    userInfo: {
      userName: ''
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
      setUserId(userId)
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
  },
  actions: {
    async login({ dispatch, commit }, userInfo) {
      // 登录
      const response = await login(userInfo)
      // 获取审核状态
      const { userId = '' } = response
      dispatch('auth/getAcctReviewStatus', userId, { root: true })
      const signToken = getToken()
      commit('SET_USER_ID', userId)
      commit('SET_TOKEN', signToken)
    },
    // 登出
    async logout({ dispatch, commit }, { remote = false } = {}) {
      if (remote) {
        await logout({})
        vab.baseMessage('登出成功！')
      }
      dispatch('resetInfo')
      routeTo('/login')
    },
    // 重置信息
    resetInfo({ commit }) {
      // 清空注册信息
      commit('auth/SET_REGISTER_INFO', null, { root: true })
      // 清空路由信息
      commit('routes/RESET_ROUTES', null, { root: true })
      // 清空cookie token信息
      removeToken()
      // 清空vuex token信息
      commit('SET_TOKEN', '')
      // 清空userID
      commit('SET_USER_ID', '')
      // 清空userInfo
      commit('SET_USER_INFO', {})
      removeUserId()
    },
    async getUserInfo({ commit }) {
      try {
        const res = await getUserInfo()
        const { email = '', mobile = '', userName } = res
        commit('SET_USER_INFO', { email, mobile, userName })
      } catch (err) {
        routeTo('/login')
      }
    }
  }
}
